import { render, staticRenderFns } from "./ProductCardListView.vue?vue&type=template&id=83fe0740&scoped=true&"
import script from "./ProductCardListView.vue?vue&type=script&lang=js&"
export * from "./ProductCardListView.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardListView.vue?vue&type=style&index=0&id=83fe0740&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fe0740",
  null
  
)

export default component.exports